<template>
    <div class="links-btn">
        <div>
            <a :href="marketing" target="_blank" @click="eventAnalytics('catalogue_produits')" class="boutonProduitsMenu" type="button" rel="noopener">
                <img alt="" :src="require(`@/assets/${marketingPicture}.png`)" :srcset="require(`@/assets/${marketingPicture}@2x.png`) + ' 2x'" />
            </a>
        </div>
        <div>
            <a v-if="sitimmoUser.univers === 'IMMO'" class="link-image-sponsorship" target="_blank" href="https://www.ubiflow.net/offre-parrainage-immobilier" rel="noopener"><img alt="" src="@/assets/marketing_sponsorship_fr.png" width="288px"/></a>
            <a v-if="sitimmoUser.univers === 'VO'" class="link-image-sponsorship" target="_blank" href="https://www.ubiflow.net/offre-parrainage-automobile" rel="noopener"><img alt="" src="@/assets/marketing_sponsorship_fr.png" width="288px"/></a>
        </div>
    </div>
</template>

<script>
import i18next from 'i18next'


export default {
  computed: {
    marketing () {
      return processEnvConfig.VUE_APP_MARKETING
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    marketingPicture () {
      if (i18next.language === 'mx') {
        return 'marketing_es'
      }
      return 'marketing_' + i18next.language
    }
  },
  methods: {
    eventAnalytics (category) {
      this.$ga.event('dashboard', 'clic', category, this.sitimmoUser.id)
      this.$router.push({ name: 'Produits' })
    }
  }
}
</script>
<style scoped>
.links-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
